// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__OUhFl","logo":"Navbar_logo__+ctS5","vertical":"Navbar_vertical__yLzX0"};